(() => {
  'use strict';
  function init(root) {
    if (!root || root.dataset.storyReady === 'true') return;
    root.dataset.storyReady = 'true';
    const cards = [...root.querySelectorAll('[data-story-card]')];
    const filters = root.querySelector('[data-story-filters]');
    const more = root.querySelector('[data-story-more]');
    const count = root.querySelector('[data-story-count]');
    let selected = root.dataset.audience || 'all';
    let shown = 4;
    function refresh() {
      const matches = cards.filter(card => selected === 'all' || card.dataset.species === selected);
      cards.forEach(card => { card.hidden = !matches.includes(card) || matches.indexOf(card) >= shown; });
      if (more) more.hidden = matches.length <= shown;
      if (count) count.textContent = matches.length ? `${Math.min(shown, matches.length)} of ${matches.length} portrait concepts` : '';
      root.querySelectorAll('[data-story-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.storyFilter === selected)));
    }
    if (cards.length) {
      if (filters) filters.hidden = false;
      refresh();
      filters?.addEventListener('click', event => {
        const button = event.target.closest('[data-story-filter]');
        if (!button) return;
        selected = button.dataset.storyFilter;
        shown = 4;
        refresh();
      });
      more?.addEventListener('click', () => {
        const previous = shown;
        shown += 4;
        refresh();
        const newlyVisible = cards.filter(card => !card.hidden)[previous]?.querySelector('a');
        // Focus remains visible when the last load hides the load-more button.
        if (more.hidden) newlyVisible?.focus({ preventScroll: true });
      });
    }

    // Progressive enhancement: without dialog support, image links still open
    // the original optimized asset and FAQ details work without JavaScript.
    if (typeof HTMLDialogElement === 'undefined' || !HTMLDialogElement.prototype.showModal) return;
    let dialog;
    let origin;
    const closeDialog = () => { if (dialog?.open) dialog.close(); };
    root.addEventListener('click', event => {
      const link = event.target.closest('[data-story-zoom]');
      if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
      event.preventDefault();
      origin = link;
      if (!dialog) {
        dialog = document.createElement('dialog');
        dialog.className = 'mpn-story-dialog';
        dialog.setAttribute('aria-label', 'Enlarged pet necklace concept');
        const close = document.createElement('button');
        close.type = 'button';
        close.className = 'mpn-story-dialog__close';
        close.textContent = '×';
        close.setAttribute('aria-label', 'Close enlarged image');
        const figure = document.createElement('figure');
        const img = document.createElement('img');
        const caption = document.createElement('figcaption');
        figure.append(img, caption);
        dialog.append(close, figure);
        root.append(dialog);
        close.addEventListener('click', closeDialog);
        dialog.addEventListener('click', e => { if (e.target === dialog) closeDialog(); });
        dialog.addEventListener('close', () => { origin?.focus({ preventScroll: true }); });
      }
      const image = dialog.querySelector('img');
      image.src = link.href;
      image.alt = link.querySelector('img')?.alt || 'Illustration of a personalized pet necklace';
      const caption = dialog.querySelector('figcaption');
      caption.textContent = link.dataset.caption || 'Personalized pet necklace concept';
      const label = document.createElement('span');
      label.className = 'mpn-story-dialog__label';
      label.textContent = 'Design illustration · finished engraving varies.';
      caption.append(label);
      dialog.showModal();
    });
    root.addEventListener('shopify:section:unload', () => dialog?.remove(), { once: true });
  }
  function scan(container = document) {
    if (container.matches?.('[data-mpn-story]')) init(container);
    container.querySelectorAll('[data-mpn-story]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  else scan();
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
